import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiFieldStatusRowStatus } from '../../types/ui-field-status-row-status.type';
import { UiMetaChipComponent } from '../ui-meta-chip/ui-meta-chip.component';

@Component({
  selector: 'ui-field-status-row',
  imports: [UiMetaChipComponent],
  templateUrl: './ui-field-status-row.component.html',
  styleUrl: './ui-field-status-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiFieldStatusRowComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly value: InputSignal<string | null> = input<string | null>(null);
  public readonly status: InputSignal<UiFieldStatusRowStatus> = input.required<UiFieldStatusRowStatus>();
  public readonly hint: InputSignal<string | null> = input<string | null>(null);
  public readonly editable: InputSignal<boolean> = input<boolean>(false);
  public readonly editLabel: InputSignal<string> = input<string>('Edytuj');
  public readonly edited: OutputEmitterRef<void> = output<void>();

  protected readonly isOk: Signal<boolean> = computed((): boolean => this.status() === 'ok');
  protected readonly isAi: Signal<boolean> = computed((): boolean => this.status() === 'ai');
  protected readonly isRequired: Signal<boolean> = computed((): boolean => this.status() === 'required');
  protected readonly isOptional: Signal<boolean> = computed((): boolean => this.status() === 'optional');
  protected readonly isBlocking: Signal<boolean> = computed((): boolean => this.status() === 'required');
  protected readonly displayValue: Signal<string> = computed((): string => this.value() ?? '—');
  protected readonly helperText: Signal<string | null> = computed((): string | null => {
    if (this.hint()) {
      return this.hint();
    }

    if (this.isRequired()) {
      return 'Wymagane';
    }

    return null;
  });
  protected readonly hasHelperText: Signal<boolean> = computed((): boolean => !!this.helperText());

  protected handleEdit(): void {
    this.edited.emit();
  }
}
